var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 458.03 361.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 429.48,
    y1: 276.1,
    x2: 446.03,
    y2: 256.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 388.9,
    y1: 278.69,
    x2: 419.68,
    y2: 251.79,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 410.68,
    y1: 204.17,
    x2: 452.33,
    y2: 277.38,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 362.94,
    y1: 344.64,
    x2: 366.82,
    y2: 122.69,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 304.9,
    y1: 262.25,
    x2: 385.87,
    y2: 262.25,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 397.65,
    y1: 223.21,
    x2: 459.74,
    y2: 104.9,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 389.99,
    y1: 132.65,
    x2: 416.93,
    y2: 132.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ead4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e9cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 294.98,
    y1: 189.26,
    x2: 294.98,
    y2: 248.59,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 191.51,
    y1: 285.33,
    x2: 188.4,
    y2: 179.27,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 237.01,
    y1: 284,
    x2: 233.91,
    y2: 177.94,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 408.5,
    y1: 345.44,
    x2: 412.38,
    y2: 123.49,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 43.83,
    y1: 314.09,
    x2: 58.58,
    y2: 183.72,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 57.3,
    y1: 152.1,
    x2: -7.24,
    y2: 189.48,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 55.8,
    y1: 203.91,
    x2: 19.58,
    y2: 120.44,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 108.55,
    y1: 149.54,
    x2: 130.38,
    y2: 149.54,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 49.16,
    y1: 177.15,
    x2: 68.86,
    y2: 177.15,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 52.6,
    y1: 108.03,
    x2: 74.33,
    y2: 108.03,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 52.36,
    y1: 107.02,
    x2: 70.8,
    y2: 114.59,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 55.7,
    y1: 107.21,
    x2: 50.31,
    y2: 107.99,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 60.83,
    y1: 128.49,
    x2: 62.51,
    y2: 104.56,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 96.37,
    y1: 145.01,
    x2: 79.81,
    y2: 191.06,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 137.16,
    y1: 42.5,
    x2: 304.44,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 216.85,
    y1: 126.11,
    x2: 291.35,
    y2: 96.11,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 270.88,
    y1: 99.32,
    x2: 314.51,
    y2: 86.56,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 137.37,
    y1: 59.49,
    x2: 143.58,
    y2: 147.7,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 148.24,
    y1: 58.73,
    x2: 154.45,
    y2: 146.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 160.06,
    y1: 57.89,
    x2: 166.27,
    y2: 146.1,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 171.7,
    y1: 57.07,
    x2: 177.91,
    y2: 145.29,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 374.22,
    y1: 159.82,
    x2: 387.75,
    y2: 159.82,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 174.64,
    y1: 271.3,
    x2: 148.26,
    y2: 281.13,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: -1837.95,
    y1: -287.32,
    x2: -1839.2,
    y2: -266.51,
    gradientTransform: "rotate(20.39 -2392.524 5552.187)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 128.55,
    y1: 260.93,
    x2: 136.83,
    y2: 303.48,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: -7491.36,
    y1: 2657.1,
    x2: -7492.61,
    y2: 2677.95,
    gradientTransform: "scale(-1 1) rotate(34.8 34.421 13219.492)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 152.91,
    y1: 243.32,
    x2: 149.63,
    y2: 297.64,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 149.69,
    y1: 273.12,
    x2: 148.69,
    y2: 289.76,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 137.26,
    y1: 301.54,
    x2: 163.89,
    y2: 301.54,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 149.98,
    y1: 292.21,
    x2: 151.79,
    y2: 300.62,
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M192.46 360.57c68.08 5.68 137.15-15.09 194.07-52.89 26.27-17.44 50.92-39.39 63.59-68.27s10.86-65.75-10.93-88.56c-16.31-17.07-41.08-24.27-56.69-42.04-12.28-14-17.23-32.79-25.51-49.49-30.21-60.89-165-85.58-219.83-22.2C84.39 98.17-37.97 129.59 11.57 259.68c23.83 62.54 119.72 95.78 180.89 100.89z",
    fill: "#4d5bed",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.78 248.68l13.82 54.83a2.34 2.34 0 002.72 1.71 2.33 2.33 0 001.85-2.59c-1.44-10.61-7.69-56.73-8-57.34s-5.26.1-8.45.51a2.33 2.33 0 00-1.94 2.88zm-15.59 0l-13.82 54.83a2.34 2.34 0 01-2.72 1.71 2.33 2.33 0 01-1.85-2.59c1.44-10.61 7.69-56.73 8-57.34s5.26.1 8.45.51a2.33 2.33 0 011.94 2.88z",
    fill: "#4d5bed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M419.67 250l13.82 54.83a2.34 2.34 0 002.72 1.71 2.33 2.33 0 001.85-2.59c-1.44-10.61-7.69-56.73-8-57.34s-5.26.1-8.45.51a2.33 2.33 0 00-1.94 2.88z",
    transform: "translate(.11 -1.32)",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M404.08 250l-13.82 54.83a2.34 2.34 0 01-2.72 1.71 2.33 2.33 0 01-1.85-2.59c1.44-10.61 7.69-56.73 8-57.34s5.26.1 8.45.51a2.33 2.33 0 011.94 2.88z",
    transform: "translate(.11 -1.32)",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M451.4 183.95c-.5 2.45-1.84 4.63-2.81 6.93-6.43 15.34 3.95 35.31-6 48.62-3.93 5.25-10.39 8.14-16.87 9.13s-13.1.3-19.62-.4l-9.49-1c-2.93-.31-5.92-.64-8.56-1.95s-4.87-3.83-5-6.77c-.16-3.63 2.76-6.57 5.37-9.1a167.77 167.77 0 0027.28-34.38c4.16-7 9.22-16.32 17.82-18.26 5.96-1.36 19.8-2.23 17.88 7.18z",
    fill: "#4d5bed"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M447.41 182.42c-.5 2.45-1.84 4.63-2.81 6.94-6.43 15.33 3.95 35.31-6 48.61-3.93 5.25-10.39 8.14-16.87 9.14s-13.1.29-19.62-.41l-9.49-1c-2.93-.32-5.92-.65-8.56-2s-4.87-3.82-5-6.76c-.16-3.64 2.76-6.58 5.37-9.11a167.77 167.77 0 0027.28-34.38c4.16-6.95 9.22-16.32 17.82-18.25 5.96-1.32 19.8-2.2 17.88 7.22z",
    transform: "translate(.11 -1.32)",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d5bed",
    d: "M361.52 209.25h5.74v104.43h-5.74z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M361.52 209.25h5.74v104.43h-5.74z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M335.11 280.12a15.69 15.69 0 00-1.84 6.49c0 4.32 3.48 7.75 6.67 10.66 2.45-6.47 6-12.69 11.23-17.2 3.52-3 29.32-34.82 33-37.66s29.51-4.06 30.09-8.65c.65-5.18-21.47-4.49-25.53-7.94-5.1-4.34-29.31 2.43-32.42 6.56-7.2 9.55-16.35 36.89-21.2 47.74z",
    fill: "#3e3e54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M335.13 281.52a15.9 15.9 0 00-1.85 6.49c.05 4.32 3.49 7.75 6.68 10.67 2.45-6.47 6-12.69 11.23-17.2 3.51-3 29.32-34.82 33-37.66s29.51-4.06 30.09-8.66c.65-5.18-21.47-4.48-25.53-7.93-5.1-4.34-29.31 2.42-32.42 6.55-7.21 9.55-16.33 36.89-21.2 47.74z",
    transform: "translate(.11 -1.32)",
    fill: "url(#g)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.86,
    y: 26.76,
    width: 259.51,
    height: 155.08,
    rx: 12.16,
    fill: "#4d5bed",
    opacity: 0.48,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M397.48 167.59a17.54 17.54 0 012.79-10.59 24.36 24.36 0 018-7.63c1.83-1.11 3.92-2.06 6-1.79 1.79.23 4.29-2.45 5.74-1.38 4.08 3 7 10.17 10.42 13.89a111.47 111.47 0 011.68 15.15l2.06 38.38c.34 6.33.52 13.26-3.3 18.33a216.69 216.69 0 01-27.86-12.41 6.18 6.18 0 01-2.23-1.67 6.3 6.3 0 01-.85-3.51q-.57-14.33 0-28.66c.18-5.16-2.04-12.96-2.45-18.11z",
    fill: "#4d5bed"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M415.06 206.75c.33-2 1-4 .62-6-.64-3.58-4.38-6.43-3.8-10 .23-1.47 1.18-2.72 1.79-4.08 1.08-2.41 1.08-5.15 1-7.79-.09-3.62-.27-7.25-.54-10.86a14 14 0 00-4.06 4.76l-7.53 12.14a21.37 21.37 0 00-2.12 4 21.72 21.72 0 00-.89 6.92l-.34 17.45c0 1.67 0 3.5 1.09 4.76a6.19 6.19 0 002.79 1.6c3.52 1.19 10.08 3.37 12.1-.56 1.76-3.4-.79-8.3-.11-12.34z",
    transform: "translate(.11 -1.32)",
    fill: "url(#h)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M404.86 213.53l-27.5 3.45c-4.65.59-9.38 1.19-13.7 3s-8.26 5.06-9.86 9.47c-3.78 10.42-2.92 21.34.52 31.87q4.21 12.84 8.41 25.68a21.54 21.54 0 003.22 6.93c1.6 2 4.15 3.45 6.68 3a3.36 3.36 0 002.35-1.44 4.73 4.73 0 00.44-2.45l.06-46.3c0-2.66.24-5.77 2.46-7.23 1.44-.94 3.28-.87 5-.77l30.58 1.79c4.4.26 19.26-5.42 18.35-11.63-1.21-8.22-18.76-16.41-27.01-15.37z",
    fill: "#3e3e54"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M368.8 294.35c-.73 1.4-.33 3.17-.94 4.64a7.15 7.15 0 01-2.34 2.65l-7.14 5.79c-1.25 1-2.65 2.47-2.15 4s2.37 1.88 3.93 1.95a83.77 83.77 0 0011.95-.49c2.49-.24 5.21-.63 6.88-2.49a7.1 7.1 0 001.56-3.55c.76-4.52-1.4-9-3.5-13a1.6 1.6 0 00-.81-.88 1.51 1.51 0 00-.86.1 19.55 19.55 0 00-4.64 2.26m-58.2 1.18a4.57 4.57 0 00-1.21 1.38 3.89 3.89 0 001.24 4.52 9.87 9.87 0 004.65 1.83 49.1 49.1 0 0012.16.77 4.95 4.95 0 005-2.69 82.5 82.5 0 005-9c1.13-2.41-1.15-3.66-3.27-4.16-1.9-.45-3.44.43-5.13 1.19-3.87 1.75-8.05 2.11-12.11 3.19a16.39 16.39 0 00-6.33 2.97z",
    fill: "#3e3e54"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M391.65 140c1.59 2 2.24 4.69 3.73 6.81a4.58 4.58 0 003.64 2.28c1.85-.07 3.14-1.81 4.76-2.71a3.87 3.87 0 003.27 1.8 8.57 8.57 0 003.76-.91 21.37 21.37 0 005.55-3.61 1.61 1.61 0 00.52-.67 1.72 1.72 0 000-.87l-3.38-15.7a15.26 15.26 0 00-2.37-6.26 9.85 9.85 0 00-3.72-2.78c-5.08-2.34-11.54-1.34-15 3.24-2.4 3.15-.52 7-1 10.57-.24 1.63-.92 3.12-1.23 4.71-.47 1.83.43 2.77 1.47 4.1z",
    transform: "translate(.11 -1.32)",
    fill: "url(#b)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M390.9 117.81c1.78 2 4.79 2.32 7.49 2.3a15.25 15.25 0 014.11.28 4.47 4.47 0 013.1 2.49c.45 1.16.19 2.47.32 3.7a2.32 2.32 0 00.61 1.48 1.07 1.07 0 001.46.05c.47-.52.45-1.69 1.13-1.57a.8.8 0 01.51.43 4.19 4.19 0 01-.08 4.48c-.57.84-1.48 1.9-.83 2.67.38.44 1 .43 1.58.63 1.79.69 1.78 3.57 3.52 4.41a2.71 2.71 0 002.51-.25 6.79 6.79 0 001.84-1.86 31.87 31.87 0 006.16-16.05 11 11 0 00-.51-5.26 10.66 10.66 0 00-3.39-4.1c-2.1-1.69-4.95-3.1-7.42-2-.77.34-1.58.92-2.37.63a2.75 2.75 0 01-.92-.71c-3.49-3.47-9.2-4.08-13.78-2.26-1.72.69-5.11 1.4-6 3.16a7.45 7.45 0 00.96 7.35z",
    fill: "#b7a451"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d5bed",
    d: "M174.62 201.68h240.71v7.83H174.62z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M174.62 201.68h240.71v7.83H174.62z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d5bed",
    d: "M187.94 209.25h5.74v104.43h-5.74zm45.56.28h5.74v105.06h-5.74z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M187.94 209.25h5.74v104.43h-5.74z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M233.5 209.53h5.74v105.06h-5.74z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d5bed",
    d: "M407.08 209.52h5.74v105.07h-5.74z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M407.08 209.52h5.74v105.07h-5.74z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.54 308.91c-.39.75-.87 1.44-1.27 2.19a10.64 10.64 0 00-1.1 6.67 6.19 6.19 0 003.05 4.7 7.19 7.19 0 003.93.39c2.1-.24 4.34-.94 5.48-2.71a8.66 8.66 0 001-4c.16-2 .28-4.12-.59-6-.67-1.42-1.9-2.55-2.43-4-.46-1.27-.44-2.82-1.46-3.7-1.22-1.05-3.66-.41-4.61.78-1.19 1.51-1.12 3.98-2 5.68zm25.78-6.41c-.41 1.23-.82 2.62-.24 3.78.74 1.5 2.67 1.85 4.13 2.66s2.39 2 3.76 2.7a11 11 0 004.64 1 62 62 0 006.25 0 11.08 11.08 0 004.5-.87 2.4 2.4 0 00.91-.69c.79-1.08-.1-2.57-1.07-3.47a14.93 14.93 0 00-5.79-3.32c-2.6-.78-5.67-1-7.3-3.18-1.21-1.6-1.33-4-2.92-5.18-4.44-3.36-6.03 4.06-6.87 6.57z",
    fill: "#4d5bed"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.42 287.01l1 12.37c.27 3.2 1 7.06 4 8.17 2.37.88 5.1-.59 6.48-2.71s1.73-4.74 2-7.25c2.68-23.65 2.92-47.69 8.42-70.84a440.29 440.29 0 016.33 63.68 18.27 18.27 0 00.86 6.21 6.07 6.07 0 004.49 4c2.47.33 4.82-1.52 5.88-3.78s1.12-4.85 1.16-7.35l1.41-90.43c.06-4.15.27-8.68 3-11.8-12.46-.07-26 .56-38.45.49a3.74 3.74 0 00-2.29.48 3.79 3.79 0 00-1.15 2.62 416.73 416.73 0 00-3.14 96.14z",
    fill: "#3e3e54"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.13 288.33l1 12.37c.26 3.2 1 7.06 4 8.17 2.38.88 5.11-.59 6.49-2.71s1.73-4.74 2-7.25c2.68-23.65 2.92-47.69 8.42-70.84a440.27 440.27 0 016.32 63.68 18.52 18.52 0 00.87 6.21 6.07 6.07 0 004.48 4c2.48.33 4.83-1.52 5.89-3.78s1.12-4.85 1.16-7.35l1.4-90.43c.07-4.15.27-8.68 3-11.8-12.46-.07-26 .56-38.45.49a3.72 3.72 0 00-2.29.48 3.79 3.79 0 00-1.15 2.62 416.74 416.74 0 00-3.14 96.14z",
    transform: "translate(.11 -1.32)",
    fill: "url(#m)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.21 153.16a3.67 3.67 0 01-.78 2.36 3.88 3.88 0 01-2 .89c-9.33 2.18-19 2.56-28.57 2.93-1.53.05-3.42-.08-4.07-1.48v5.12c0 5.56-.12 11.33 0 16.69a20.86 20.86 0 01-.64 6.83c-1.39 4.3-5.47 7.29-9.79 8.6s-8.94 1.17-13.46 1l-14.3-.42a9.53 9.53 0 01-3.64-.58c-3.22-1.43-3.85-5.66-4-9.17-.44-10.13-.24-20.63.14-31.07.27-7.45.63-14.86.91-22.08.13-3.29 2.26-6.25 4.93-8.16a28.69 28.69 0 019.05-3.83 44.94 44.94 0 009.29-3.27 43.3 43.3 0 0116.09 5.94 26.61 26.61 0 0111.4 13.06c.86 2.28 1.46 4.89 3.43 6.33s4.44 1.21 6.76 1.06a110.06 110.06 0 0114.3.07c1.55.1 3.3.34 4.25 1.58a5.3 5.3 0 01.8 3 36.38 36.38 0 01-.1 4.6z",
    fill: "#4d5bed"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.45 165c-1-.54-2-1-2.9-1.57s-1.7-1.16-2.52-1.77l-5.16-3.9a6 6 0 01-1-.91 4.1 4.1 0 01-.82-3 10.19 10.19 0 01.92-3.06c.58-1.35 1.26-2.84.84-4.26-.51-1.77-2.49-2.66-4.3-3a2.1 2.1 0 00-.9 0 2 2 0 00-1.2 1.22 15.43 15.43 0 00-1.15 5.18l-.65 6.23a6.71 6.71 0 000 2c.42 1.86 2.31 2.93 3.91 4a88 88 0 017.11 5.68 20 20 0 007.93 4.31 7.41 7.41 0 003.74 0 4.5 4.5 0 002.09-1.3c.91-1 .29-1.3-.63-2.06a37.85 37.85 0 00-5.31-3.79z",
    transform: "translate(.11 -1.32)",
    fill: "url(#n)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M66.82 185s-5.57 2.2-10-.77-11.13-7.38-11.13-7.38l-10.34-4v17.33s.26 5.45 3.1 6.86a9.53 9.53 0 01-3.64-.58c-3.22-1.43-3.85-5.66-4-9.17-.44-10.13-.24-20.63.14-31.07l29 22.19z",
    transform: "translate(.11 -1.32)",
    fill: "url(#o)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.51 151.77a8 8 0 00-.69 3.78 7.24 7.24 0 001.95 3.58c5.46 6.3 13.29 9.93 20.87 13.38a10.32 10.32 0 004 1.21c3.61 0 5.09-2.27 5.6-5.84a3.53 3.53 0 00-.06-1.68 4.31 4.31 0 00-1.89-1.89c-4.22-2.72-10-4.77-13.55-8.33a3 3 0 01-1-1.72c-.08-.83 8.16-14.22 6.25-18.81s-4.34-11.64-9.14-8.83c-6.86 4.06-10.28 19.41-12.34 25.15z",
    fill: "#4d5bed"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.65 143.19a.91.91 0 01.78-.09.81.81 0 01.32.65 6 6 0 01-.38 3l5.36.48c1.68.15 3.65.48 4.39 2s-.41 3.61-1.91 4.65c-2.66 1.84-6.08 2.09-9.31 2.15a18 18 0 01-5.72-.54c-2.81-.87-6.13-4.1-3.9-7 1.96-2.64 7.54-3.99 10.37-5.3z",
    transform: "translate(.11 -1.32)",
    fill: "url(#p)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.38 170a4 4 0 011.74.46 1.35 1.35 0 01.63 1.55c-.46 1.15-2.67.87-2.86 2.1a1.82 1.82 0 00.67 1.38l3.17 3.39a8.45 8.45 0 011.94 2.75 2.82 2.82 0 01-.68 3.11 3.82 3.82 0 01-3 .4 21.51 21.51 0 01-14.94-10.55c-4.59-8.25 9.63-4.97 13.33-4.59z",
    transform: "translate(.11 -1.32)",
    fill: "url(#q)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M74.23 97.74c-.26 2.69-.54 5.39-.81 8.08a3.47 3.47 0 01-.16.91c-.12.31-.33.58-.46.9a4.35 4.35 0 00-.15 1.94c.2 3 0 6.34-2 8.65a5.21 5.21 0 01-1.22 1.07 6.61 6.61 0 01-4.28.59 4.25 4.25 0 00-1.18 0 1.11 1.11 0 00-.69.32 2 2 0 00-.41.73 13.93 13.93 0 00-.5 1.67 3.72 3.72 0 01-.79 1.85 2.38 2.38 0 01-1.72.53 4 4 0 01-.85-.12 10.66 10.66 0 01-3.66-1.93 4.1 4.1 0 01-2.15-4.07l-.46-8.54c-.22-4-.4-8.13 1.22-11.77a12.59 12.59 0 0114.94-7 8.34 8.34 0 012.35 1 10.36 10.36 0 012.53 2.5c.73.95.56 1.53.45 2.69z",
    transform: "translate(.11 -1.32)",
    fill: "url(#r)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.87 94.4a24.89 24.89 0 01-4.65 0 11.29 11.29 0 00-5 1 8 8 0 00-4.34 6.39c-.08.92-.18 2.12-1.08 2.34s-1.42-.56-2.19-.64a1.79 1.79 0 00-1.8 1.58 3.93 3.93 0 00.67 2.51 17.44 17.44 0 011.34 2.28 4.75 4.75 0 01-1 4.93 16 16 0 01-3.6-8.09 31.15 31.15 0 01.06-8.94 8.53 8.53 0 01.82-3c.26-.46.61-.88.87-1.34.42-.76.62-1.63 1-2.43a8.79 8.79 0 015-4.49 16.37 16.37 0 016.78-.88 13.45 13.45 0 004.36-.17c2.41-.69 7.85-3.23 9 .76 1.1 3.77-2.84 7.6-6.24 8.19z",
    fill: "#3e3e54"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.92 103.61a1.19 1.19 0 00-1.32.77 3.69 3.69 0 00-.38 1.78 2 2 0 00.89 1.52 2.74 2.74 0 001.24.27 12.38 12.38 0 002.58-.15.63.63 0 00.33-.12.59.59 0 00.13-.41l.11-1.81a2.63 2.63 0 00-.08-1.05c-.47-1.25-2.5-.88-3.5-.8zm7.56 0a1.6 1.6 0 00-1.05.35 1.41 1.41 0 00-.26.42 3.58 3.58 0 00-.38 1.78 1.91 1.91 0 00.9 1.53 2.73 2.73 0 001.23.27 12.44 12.44 0 002.59-.15.57.57 0 00.32-.12.55.55 0 00.13-.41l.11-1.81a2.31 2.31 0 00-.08-1.05c-.47-1.26-2.5-.89-3.51-.81z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.77
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 104a1.35 1.35 0 00-.53-.06 3.07 3.07 0 00-1.76.7 2.05 2.05 0 00-.5.6 2.39 2.39 0 00-.15 1.3 4.33 4.33 0 00.87 2.35c.32.39 2.07 2.06 2.57 2.09s1.53-.77 1.88-1.19c.49-.61-.62-2.82-.67-3.62a3.61 3.61 0 00-1.71-2.17z",
    transform: "translate(.11 -1.32)",
    fill: "url(#s)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.43 107.24a1.15 1.15 0 000-.37.78.78 0 00-.15-.32 1.48 1.48 0 00-1.43-.55.92.92 0 00-.73.57 1.21 1.21 0 00.1.85 5.07 5.07 0 00.5 1 2.54 2.54 0 00.76.77 1.23 1.23 0 001.05.13c.32-.12.71-.57.45-.9-.13-.16-.33-.21-.44-.41a1.26 1.26 0 01-.11-.77z",
    transform: "translate(.11 -1.32)",
    fill: "url(#t)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M64 119.86a1.11 1.11 0 00-.69.32 2 2 0 00-.41.73 13.93 13.93 0 00-.5 1.67 3.72 3.72 0 01-.79 1.85 2.38 2.38 0 01-1.72.53 4 4 0 01-.85-.12 4.18 4.18 0 01-.31-2.12 14.47 14.47 0 01.23-1.87 1.34 1.34 0 01.33-.82 1.52 1.52 0 011.1-.28h2.86a4.44 4.44 0 01.75.11z",
    transform: "translate(.11 -1.32)",
    fill: "url(#u)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.36 162.97l.47-5.11v5.12z",
    fill: "#4d5bed"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 154.48a3.67 3.67 0 01-.78 2.36 3.88 3.88 0 01-2 .89c-9.33 2.18-19 2.56-28.57 2.93-1.53.05-3.42-.08-4.07-1.48v-13.53s2.64 8.28 7 8 26.13-1.29 26.13-1.29z",
    transform: "translate(.11 -1.32)",
    fill: "url(#v)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M137.16 37.12h167.28v10.76H137.16z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M304.36 117a32.07 32.07 0 11-28.51-46.76h.22v32.06z",
    transform: "translate(.11 -1.32)",
    fill: "url(#w)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M307.92 102.34a32 32 0 01-3.56 14.7l-28.29-14.7V70.28a32.06 32.06 0 0131.85 32.06z",
    transform: "translate(.11 -1.32)",
    fill: "url(#x)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M137.16 84.66h7.18v45.75h-7.18z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M148.56 98.18h7.18v32.22h-7.18z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M159.96 84.66h7.18v45.75h-7.18z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M171.36 76.08h7.18v54.33h-7.18z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M402.11 188.35l-10.81 9.61c-2.43 2.17-5.28 4.48-8.53 4.18a7.86 7.86 0 01-5.49-3.55 19.18 19.18 0 01-2.52-6.23 70.27 70.27 0 01-1.48-26.9 2.07 2.07 0 01.36-1.06 2.13 2.13 0 011.61-.51l5.09-.15a2.45 2.45 0 013 1.79l4.77 10.85c3.59-3.76 9.27-16.25 12.85-20 .89-.94 9.44-8.67 13.58 8.53 1.43 6-7.78 19.3-12.43 23.44z",
    fill: "#4d5bed"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M374.36 157.42a6.84 6.84 0 01.66-2.62 6.48 6.48 0 012-2.07 20.17 20.17 0 015-2.64 4 4 0 012-.33 3.37 3.37 0 011.81 1 6.68 6.68 0 011.44 7.18c-1.12 2.64-3.89 4.4-4.64 7.17-.32 1.19-.26 2.57-1.05 3.52a4.43 4.43 0 01-3.11 1.22c-2.86.27-3.62-.6-3.84-3.11a48.59 48.59 0 01-.27-9.32z",
    transform: "translate(.11 -1.32)",
    fill: "url(#C)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M404.66 152.01v-3.8a1.41 1.41 0 01.16-.7 1.32 1.32 0 01.61-.42c1.75-.73 3.66-1.07 5.37-1.89 2.16-1 4.11-2.84 6.5-2.81a.92.92 0 01.67.2 1 1 0 01.25.49c.29.94.54 1.89.75 2.86a.63.63 0 010 .45.66.66 0 01-.38.26l-2.47.92c-3.95 1.45-8.01 2.05-11.46 4.44zM154.29 273.28c1.7-5.47 4.34-10.78 8.49-14.73s10-6.38 15.64-5.55c2.05.3 4.2 1.14 5.23 2.94a6 6 0 01-.58 6.16 18 18 0 01-4.78 4.38 67.18 67.18 0 00-11.18 9.34 25.56 25.56 0 00-5.47 9.18c-.76 2.39-.06 6.29-2 8.06a5 5 0 01-5.45.49c-2.51-1.41-2.09-4.92-2.06-7.4a45.74 45.74 0 012.16-12.87z",
    fill: "#4d5bed"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M154.18 274.6c1.7-5.47 4.34-10.78 8.49-14.73s10-6.38 15.64-5.55c2.05.3 4.2 1.14 5.23 2.94a6 6 0 01-.58 6.16 18 18 0 01-4.78 4.38 67.18 67.18 0 00-11.18 9.34 25.56 25.56 0 00-5.47 9.18c-.76 2.39-.06 6.29-2 8.06a5 5 0 01-5.45.49c-2.51-1.41-2.09-4.92-2.06-7.4a45.74 45.74 0 012.16-12.87z",
    transform: "translate(.11 -1.32)",
    fill: "url(#D)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M155 282.22a15.45 15.45 0 01-.43-2.78 5.72 5.72 0 012.12-4.46 21 21 0 012-1.29 5.25 5.25 0 002.75-3.92c0-.63-.14-1.26-.11-1.88a1.62 1.62 0 01.94-1.51 1.83 1.83 0 011.82.88 6.84 6.84 0 011.27 3.8 12.3 12.3 0 01-.6 4 10.16 10.16 0 01-3.91 5.83 25.5 25.5 0 00-2.48 1.45 8.5 8.5 0 00-2.31 3.79c-.06.15-.74 6.2-.87 6.3-.86.66.09-6.83.12-7.13a12.72 12.72 0 00-.31-3.08z",
    transform: "translate(.11 -1.32)",
    fill: "url(#E)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M139.33 285.76a17.2 17.2 0 00-5.14-3.23 96 96 0 01-10.7-6.12c-1.6-1.06-3.27-2.31-3.83-4.15s.06-3.6.65-5.33 1.59-4.05 3.54-4.45a5.27 5.27 0 013.07.58 28.78 28.78 0 0114 12.9 45.46 45.46 0 012 4.4 86.74 86.74 0 013.45 10.9c.64 2.64-1.34 7.42-3.54 3.48-1.72-2.92-.98-6.32-3.5-8.98z",
    fill: "#4d5bed"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M139.22 287.08a17.2 17.2 0 00-5.14-3.23 96 96 0 01-10.7-6.12c-1.6-1.06-3.27-2.31-3.83-4.15s.06-3.6.65-5.33 1.59-4.05 3.54-4.45a5.27 5.27 0 013.07.58 28.78 28.78 0 0114 12.9 45.46 45.46 0 012 4.4 86.74 86.74 0 013.45 10.9c.64 2.64-1.34 7.42-3.54 3.48-1.72-2.92-.98-6.32-3.5-8.98z",
    transform: "translate(.11 -1.32)",
    fill: "url(#F)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M141.91 282.4a14 14 0 00-.24-2.51 5.12 5.12 0 00-2.83-3.42 20.32 20.32 0 00-2-.68 4.68 4.68 0 01-3.26-2.8c-.16-.55-.16-1.13-.33-1.67a1.42 1.42 0 00-1.15-1.1c-.64 0-1.13.57-1.38 1.17a6.08 6.08 0 00-.27 3.58 10.83 10.83 0 001.4 3.35 9.11 9.11 0 004.69 4.21 22.8 22.8 0 012.48.72 7.48 7.48 0 012.85 2.79c.08.12 3.1 8 3.24 8 .89.39-2.68-8.65-2.77-8.91a11.06 11.06 0 01-.43-2.73z",
    transform: "translate(.11 -1.32)",
    fill: "url(#G)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M143.61 285.21a52.42 52.42 0 01-4.47-8 18.68 18.68 0 011.4-16.08 72.18 72.18 0 014.71-6.23c3.29-4.32 5.69-10 4-15.12-.66-2-1.86-3.69-2.47-5.65s-.46-4.42 1.16-5.68c1.85-1.43 4.58-.62 6.56.64a22.11 22.11 0 018.19 10.16 39.26 39.26 0 012.73 12.91c.49 7.79-.6 16.08-5.34 22.29-1.9 2.48-4.33 4.57-5.94 7.25-2.51 4.2-2.74 9.33-2.75 14.22a3 3 0 01-.29 1.56c-1.88 3-2.7-2.29-3-3.23-.89-3.13-2.82-6.28-4.49-9.04z",
    fill: "#4d5bed"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 286.53a52.42 52.42 0 01-4.47-8 18.68 18.68 0 011.4-16.08 72.18 72.18 0 014.71-6.23c3.29-4.32 5.69-10 4-15.12-.66-2-1.86-3.69-2.47-5.65s-.46-4.42 1.16-5.68c1.85-1.43 4.58-.62 6.56.64a22.11 22.11 0 018.19 10.16 39.26 39.26 0 012.73 12.91c.49 7.79-.6 16.08-5.34 22.29-1.9 2.48-4.33 4.57-5.94 7.25-2.51 4.2-2.74 9.33-2.75 14.22a3 3 0 01-.29 1.56c-1.88 3-2.7-2.29-3-3.23-.89-3.13-2.82-6.28-4.49-9.04z",
    transform: "translate(.11 -1.32)",
    fill: "url(#H)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M146.81 286.36a16.93 16.93 0 01-1.37-2.46 5.72 5.72 0 01.43-4.92 20.42 20.42 0 011.45-1.91c1-1.32 1.74-3.06 1.21-4.63-.2-.6-.57-1.13-.76-1.73a1.61 1.61 0 01.36-1.74 1.82 1.82 0 012 .19 6.82 6.82 0 012.51 3.12 12.08 12.08 0 01.84 4 10.21 10.21 0 01-1.64 6.83 25.54 25.54 0 00-1.82 2.22 8.37 8.37 0 00-.84 4.35 1 1 0 01-.09.48c-.58.93-.83-.7-.91-1a12.08 12.08 0 00-1.37-2.8z",
    transform: "translate(.11 -1.32)",
    fill: "url(#I)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d5bed",
    d: "M137.26 291.37h26.63l-6.29 20.34h-14.88l-5.46-20.34z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M137.26 291.37h26.63l-6.29 20.34h-14.88l-5.46-20.34z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d5bed",
    d: "M136 291.4h28.84v5.69H136z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M136 291.4h28.84v5.69H136z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation2);
export default __webpack_public_path__ + "static/media/presentation2.a22f06a59eb21707641e7c0a8eca9a9d.svg";
export { ForwardRef as ReactComponent };